import { render, staticRenderFns } from "./VehicleTypeActionsButton.vue?vue&type=template&id=48828389&"
import script from "./VehicleTypeActionsButton.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports